import { LoyaltyCampaign, LoyaltyCampaignPointsStyles } from '@/types'
import { CSSProperties } from 'react'

export const getPoints = (productPrice: number, campaign?: LoyaltyCampaign) => {
  if (!campaign) return undefined
  return Math.ceil(campaign.pointsPerDollar * productPrice)
}
// TODO: calc should come from loyaltyCampaign context
export const getRedeemPoints = (productPrice: number) => {
  return Math.ceil(productPrice / 0.006)
}

export const getPointsStyles = (handlerKey?: string): LoyaltyCampaignPointsStyles => {
  if (handlerKey === 'virgin') {
    return {
      containerStyle: { color: '#E10A0A' },
      separatorStyle: { margin: '0 5px', color: '#646464' },
      pointsStyle: { fontWeight: 'bold' },
      descriptionStyle: undefined,
    }
  }

  return { containerStyle: undefined, separatorStyle: undefined, pointsStyle: undefined, descriptionStyle: undefined }
}

export const getPointsBadgeStyles = (handlerKey?: string) => {
  if (handlerKey === 'virgin') {
    const styles: CSSProperties = {
      background: 'linear-gradient(to right, #E10A0A, #512699)',
      color: 'white',
      borderRadius: '3px',
      padding: '5px 10px',
    }
    return styles
  }

  return undefined
}

export const getPointsDescription = (handlerKey?: string) => {
  if (handlerKey === 'virgin') return 'Velocity Points'
  return undefined
}

export const getPointsBadgeIcon = (handlerKey?: string) => {
  // TODO virgin icon
  if (handlerKey === 'virgin') return 'velocityPointsWhite'
  return undefined
}
